"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayComponent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bodyScrollLock = require("body-scroll-lock");

var _index = _interopRequireDefault(require("./index.styled"));

var _Button = require("../Button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var OverlayComponent = function OverlayComponent(_ref) {
  var _ref$pageSpacing = _ref.pageSpacing,
      pageSpacing = _ref$pageSpacing === void 0 ? false : _ref$pageSpacing,
      _ref$lightbox = _ref.lightbox,
      lightbox = _ref$lightbox === void 0 ? false : _ref$lightbox,
      _ref$fit = _ref.fit,
      fit = _ref$fit === void 0 ? 'cover' : _ref$fit,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? '#FFF' : _ref$background,
      onClose = _ref.onClose,
      children = _ref.children;
  var overlayScrollRef = (0, _react.useRef)();

  var handleCloseButton = function handleCloseButton(e) {
    if (onClose) onClose();
  };

  (0, _react.useEffect)(function () {
    (0, _bodyScrollLock.disableBodyScroll)(overlayScrollRef.current);
    return function () {
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    };
  }, []);

  var handleKeydown = function handleKeydown(e) {
    if (e.key === 'Escape') {
      handleCloseButton(e);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_index.default.SubpageOverlayContainer, null, /*#__PURE__*/_react.default.createElement(_index.default.SubpageOverlayBackground, {
    onClick: handleCloseButton
  }, "Close Overlay"), /*#__PURE__*/_react.default.createElement(_index.default.SubpageOverlay, {
    fit: lightbox ? 'lightbox' : fit,
    background: background,
    onKeyDown: handleKeydown
  }, /*#__PURE__*/_react.default.createElement(_index.default.PageContent, {
    className: "is-scrollable",
    pageSpacing: pageSpacing,
    ref: overlayScrollRef,
    fit: lightbox ? 'lightbox' : fit
  }, /*#__PURE__*/_react.default.createElement(_index.default.ChildrenWrapper, {
    pageSpacing: pageSpacing
  }, children))));
};

exports.OverlayComponent = OverlayComponent;
OverlayComponent.propTypes = {
  /** Component's ID */
  id: _propTypes.default.string,

  /** Adds spacing at the top of overlay */
  pageSpacing: _propTypes.default.bool,

  /** Controls if overlay will take over entire window or be a set width/height, override fit with 'lightbox' */
  lightbox: _propTypes.default.bool,

  /** Controls sizing of lightbox
   * child - Conform to size of children
   * cover - Takes over page
   * lightbox - Has a set width and height
   */
  fit: _propTypes.default.oneOf(['child', 'cover', 'lightbox']),

  /** Theme of close button */
  buttonTheme: _propTypes.default.oneOf(['default']),

  /** Close handler */
  onClose: _propTypes.default.func,

  /** Overlay content */
  children: _propTypes.default.node,

  /** Setting nested will keep the overlay from enabling/disabling scroll locks */
  nested: _propTypes.default.bool,

  /** Hides close button */
  hideClose: _propTypes.default.bool
};